<div>
  <div>
    <p>{{'UserPages.UserProductCertificates.DescriptionText' | translate}}</p>
  </div>
  <p-table
  [value]="certificates"
  [(selection)]="selectedRows"
  [paginator]="true"
  [rows]="10"
  selectionMode="multiple"
  dataKey="id"
>
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3em">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th><div class="flex justify-content-center align-items-center">{{'UserPages.UserProductCertificates.NameHeader' | translate}}</div></th>
        <th><div class="flex justify-content-center align-items-center">{{'UserPages.UserProductCertificates.CertificateTypeHeader' | translate}}</div></th>
        <th><div class="flex justify-content-center align-items-center">{{'UserPages.UserProductCertificates.ProducerCodeHeader' | translate}}</div></th>
        <th><div class="flex justify-content-center align-items-center">{{'UserPages.UserProductCertificates.ExpireDateHeader' | translate}}</div></th>
        <th><div class="flex justify-content-center align-items-center">PDF</div></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
      <tr>
        <td>
          <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
        </td>
        <td><div class="flex justify-content-center align-items-center">{{rowData.name}}</div></td>
        <td><div class="flex justify-content-center align-items-center">{{rowData?.productCertificateType.name}}</div></td>
        <td><div class="flex justify-content-center align-items-center">{{rowData.producerCode}}</div></td>
        <td><div class="flex justify-content-center align-items-center">{{rowData.expirationDate | date:'dd-MM-yyyy'}}</div></td>
        <td>
            <div class="flex justify-content-center align-items-center">
              <p-button pTooltip="Document PDF" (onClick)="getPdfUrl(rowData)" icon="pi pi-file-pdf" styleClass="p-button-outlined"></p-button>
            </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div class="flex justify-content-end gap-1" style="margin-top: 20px;">
    <p-button (onClick)="cancel()" label="{{'UploadExport.CancelButton' | translate}}" styleClass="p-button-outlined"></p-button>
    <p-button (onClick)="saveCertificateEvent()" label="{{'UploadExport.AssignButton' | translate}}"></p-button>
  </div>
</div>
